import { observable, action, makeObservable } from 'mobx';
import { OrderTypes } from 'common/constants/trading.constants';

export class NewDealStore {
  @observable limitOfInvestment = 0.1;

  @observable closeAtLoss = true;

  @observable isFullFormShown = false;

  @observable openAtPrice = false;

  @observable closeAtProfit = false;

  @observable openAtPriceOf = 0;

  @observable closeAtProfitOf = 0;

  @observable closeAtLossOf = 0;

  @observable currentSymbolProperties = {
    kRate: 0,
    contractSize: 0,
    calcMode: '',
    price: {
      ask: 0,
      bid: 0,
    },
    leverage: 0,
    minVolume: {
      [OrderTypes.Buy]: 0,
      [OrderTypes.Sell]: 0,
    },
    maxVolume: 0,
    volumeStep: 0,
    digits: 0,
    commission: 0,
    marginRate: {
      [OrderTypes.Buy]: 0,
      [OrderTypes.Sell]: 0,
    },
  };

  @observable takeProfitLevel = 0;

  @observable stopLossLevel = 0;

  @observable action;

  @action setLimitOfInvestment = (value) => {
    this.limitOfInvestment = value;
  };

  @action setCloseAtLoss = (value) => {
    this.closeAtLoss = value;
  };

  @action toggleCloseAtLoss = () => {
    this.closeAtLoss = !this.closeAtLoss;
  };

  @action toggleOpenAtPrice = () => {
    this.openAtPrice = !this.openAtPrice;
  };

  @action setOpenAtPrice = (value) => {
    this.openAtPrice = value;
  };

  @action setCloseAtProfit = (value) => {
    this.closeAtProfit = value;
  };

  @action toggleCloseAtProfit = () => {
    this.closeAtProfit = !this.closeAtProfit;
  };

  @action setOpenAtPriceOf = (value) => {
    this.openAtPriceOf = value;
  };

  @action setCloseAtProfitOf = (value) => {
    this.closeAtProfitOf = value;
  };

  @action setIsFullFormShown = (value) => {
    this.isFullFormShown = value;
    if (!this.isFullFormShown) {
      this.onFormCollapse();
    }
  };

  @action onFormCollapse = () => {
    this.setCloseAtLoss(true);
    this.setCloseAtProfit(false);
    this.setOpenAtPrice(false);
    this.setCloseAtProfitOf(0);
    this.setOpenAtPriceOf(0);
  };

  @action setCurrentSymbolProperties = (values) => {
    this.currentSymbolProperties = {
      ...this.currentSymbolProperties,
      ...values,
    };
  };

  @action setTakeProfitLevel = (value) => {
    this.takeProfitLevel = value;
  };

  @action setStopLossLevel = (value) => {
    this.stopLossLevel = value;
  };

  @action setAction = (action) => {
    this.action = action;
  };

  @action clearStore = () => {
    this.setCloseAtLoss(true);
    this.setIsFullFormShown(false);
    this.setOpenAtPrice(false);
    this.setCloseAtProfit(false);
    this.setOpenAtPriceOf(0);
    this.setAction(null);
    this.setCloseAtProfitOf(0);
    this.setTakeProfitLevel(0);
    this.setStopLossLevel(0);
    this.setLimitOfInvestment(0.1);
  };

  constructor() {
    makeObservable(this);
  }
}
